import gql from "graphql-tag";

const UPDATE_HASHED_EMAIL_LATEST_STATUS = gql`
  mutation updateHashedEmailLatestStatus(
    $orgID: ID!
    $hashedEmailListIds: [ID]
  ) {
    updateHashedEmailLatestStatus(
      data: { 
        orgID: $orgID
        hashedEmailListIds: $hashedEmailListIds
      }
    )
  }
`;

export default UPDATE_HASHED_EMAIL_LATEST_STATUS;